import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { reasons as styles } from '../styles';
import { EMPTY_REASONS } from '../../../libraries/texts';

const Reasons = props => {
  const { classes, state, reasons } = props;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <div className={classes.flexHReasons}>
          <div>Razones</div>
          <div>Glosa</div>
        </div>
        {state && state.name ? (
          reasons && reasons.length > 0 ? (
            reasons.map(({ code, decision }, index) => (
              <div key={index.toString()} className={classes.flexHReasons}>
                <div>{code}</div>
                <div>{decision}</div>
              </div>
            ))
          ) : (
            <div className={classes.flexHReasons}>
              <div>{EMPTY_REASONS}</div>
            </div>
          )
        ) : (
          <div className={classes.flexHReasons} />
        )}
      </CardContent>
    </Card>
  );
};

Reasons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Reasons);
